import React, { useEffect } from 'react'

const useDfpSlot = ({ path, sizes, id, category }) => {
  console.log('dfp', path, sizes, id, category)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        const googletag = window.googletag || {}
        googletag.cmd = googletag.cmd || []
        googletag.destroySlots()

        googletag.cmd.push(function() {
          googletag.defineSlot(path, sizes, id).addService(googletag.pubads())
          googletag.pubads().enableSingleRequest()
          googletag.pubads().setTargeting('CAT', [category])
          googletag.enableServices()
        })
        googletag.cmd.push(function() {
          googletag.display(id)
        })
      } catch (err) {
        console.log(err)
      }
    }
  }, [])
}

export default useDfpSlot
